import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

import Spinner from '../spinner/spinner';

const LOADER_ACTIVE_CLASS = 'loader--active';

const Loader = () => {
  const loaderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    loaderRef.current?.classList.add(LOADER_ACTIVE_CLASS);
  }, []);

  return ReactDOM.createPortal(
    <div
      ref={loaderRef}
      className={classNames(
        'loader',
        'flex',
        'flex--justify-center',
        'flex--align-center'
      )}
    >
      <Spinner size="large" />
    </div>,
    document.body
  );
};

export default Loader;
